function getDigimonNumber(digimonNumber: number = 0): string {
  const formattedNumber = String(digimonNumber).padStart(3, '0');
  return `#${formattedNumber}`;
}

export default getDigimonNumber;
